module.exports = __webpack_public_path__ + "static/media/IMG_0822.20d57d3e.jpg";